<template>
  <div class="checkActivity">
    <div class="header">
      <router-link to="createcheckAct">
        <el-button type="primary" size="small">创建买单活动</el-button>
      </router-link>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="全部项目" name="first">
        <div class="tables">
          <template>
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="date" label="项目名称" min-width="180"></el-table-column>
              <el-table-column prop="name" label="状态" min-width="180"></el-table-column>
              <el-table-column prop="address" label="最近变更时间" min-width="180"></el-table-column>
              <el-table-column prop="address" label="操作" min-width="180"></el-table-column>
            </el-table>
          </template>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已上线项目" name="second">已上线项目</el-tab-pane>
      <el-tab-pane label="待上线项目" name="third">待上线项目</el-tab-pane>
      <el-tab-pane label="已下线项目" name="fourth">已下线项目</el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "checkActivity", //买单项目
  data() {
    return {
      activeName: "first",
      itemClass: "",
      stepActive: 1,
      tableData: []
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.checkActivity {
  width: 100%;
  padding: 15px 25px;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  .header {
    margin-bottom: 30px;
  }
  .tables {
    border: 1px solid rgba(235, 238, 245, 1);
  }
}
</style>

<style lang="scss">
.checkActivity {
  .cell {
    text-align: center;
  }
}
</style>
